import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  page: {
    width: "96%",
    height: 750,
    [theme.breakpoints.down('md')]: {
      width: "100%",
      paddingBottom: 48,
    },
  },
  topArea: {
    padding: "16px 0",
    display: "flex",
    flexDirection: "row-reverse",
  },
  table: {
    minWidth: 650,
  },
  link: {
    textDecoration: "none",
  },
}));
